import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConstants } from '../constants/app-constants';
import { DatePipe } from '@angular/common';
import { UserAndFileAuditService } from './user-and-file-audit.service';
import { DataOrgComponent } from '../utility/data-organization/data-org.component';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import * as moment from 'moment';

@Component({
  selector: 'app-user-and-file-audit',
  templateUrl: './user-and-file-audit.component.html',
  styleUrls: ['./user-and-file-audit.component.scss']
})
export class UserAndFileAuditComponent implements OnInit {
  userandfileaudit_label = AppConstants.userandfileaudit.USER_AND_FILE_AUDIT;
  fromDatePH = AppConstants.errorandWarning.FROM_DATE;
  toDatePH = AppConstants.errorandWarning.TO_DATE;
  apps_label = AppConstants.errorandWarning.APPS_LABEL;
  date_time_label = AppConstants.errorandWarning.DATE_TIME_LABEL;
  app_label = AppConstants.errorandWarning.APP_LABEL;
  message_label = AppConstants.errorandWarning.MESSAGE_LABEL;
  users_label = AppConstants.userandfileaudit.USERS_LABEL;
  file_label = AppConstants.userandfileaudit.FILE_LABEL;
  search = AppConstants.COMMONCONSTANT.search;
  path_selection = AppConstants.userandfileaudit.PATH_SELECTION;
  today = new Date();
  fromDate: any;
  toDate: any;
  start_date: any;
  end_date: any;
  appsList = ['All'];
  usersList: any = {};
  selectedAppItem: any;
  selectedUserItem: any;
  allAppsList = [];
  applicationId: any;
  fileSelectionPopupVisible = false;
  dataOrgVisible = false;
  @ViewChild(DataOrgComponent) dataOrgComp;
  selected_data_org_node: Object;
  dataOrgNodeId: any;
  currentNode = 'data org';
  isFolderValidation = false;
  filePath: any;
  userandfileAuditRecords: any = {};
  searchVal: any;
  isMessagePopup = false;
  messageValue: any;
  from: any;
  to: any;
  @ViewChild('userandfileAuditGrid') userandfileAuditGrid: any;
  constructor(private userandfileauditService: UserAndFileAuditService) {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.start_date = this.addDays(this.fromDate, 0);
    this.end_date = this.addDays(this.toDate, 0);
    console.log(this.start_date, this.end_date);
    this.from = moment(this.start_date + ' 00:00').utc().format('YYYY-MM-DD HH:mm');
    this.to = moment(this.end_date + ' 23:59').utc().format('YYYY-MM-DD HH:mm');
  }

  ngOnInit() {
    this.getAllAppsList();
    this.initializeletiable();
    this.getUserandFileAudit();
    this.getAppUsers();
  }

  initializeletiable() {
    this.currentNode = 'data org';
  }

  getUserandFileAudit() {
    const outerScope = this;
    this.userandfileAuditRecords.store = new CustomStore({
      load: function (loadOptions: any) {
        loadOptions.userData = {
          'from_date': outerScope.from,
          'to_date': outerScope.to,
          'app_id': outerScope.selectedAppItem,
          'user_email': outerScope.selectedUserItem,
          'file_path': outerScope.filePath
        };
        let appName: any;
        let userEmail: any;
        let isSorting = false;
        if (loadOptions.filter !== undefined) {
          outerScope.searchVal = loadOptions.filter[0].filterValue;
        } else {
          outerScope.searchVal = '';
        }
        if (loadOptions.userData.app_id === 'All' || loadOptions.userData.app_id === '') {
          appName = '';
        } else {
          appName = loadOptions.userData.app_id;
        }

        if (loadOptions.userData.user_email === 'All' || loadOptions.userData.user_email === '') {
          userEmail = '';
        } else {
          userEmail = loadOptions.userData.user_email;
        }
        const requestBody = {
          'page_no': ((loadOptions.skip / loadOptions.take) + 1),
          'page_size': loadOptions.take,
          'from_date': loadOptions.userData.from_date,
          'to_date': loadOptions.userData.to_date,
          'file_path': loadOptions.userData.file_path,
          'app_id': appName,
          'log_type': 'AUDIT',
          'user_email': userEmail,
          'search_value': outerScope.searchVal,
          'isLoadingAll': loadOptions.isLoadingAll,
          'isSorting': isSorting
        };
        return new Promise((resolve, reject) => {
          outerScope.userandfileauditService.getAllAudits(requestBody).subscribe(res => {
            console.log(res);
            if (res && res.status_code === '200') {
              if (res.nodes && res.nodes.length > 0) {
                const response = {
                  data: res.nodes,
                  totalCount: res.totalCount
                };
                resolve(response);
              } else {
                const response = {
                  data: res.nodes,
                  totalCount: 0
                };
                resolve(response);
              }
            } else {
              outerScope.userandfileAuditRecords = [];
            }
          }, err => {
            outerScope.notifyStatus('Error while fetching records', 'error');
            outerScope.userandfileAuditRecords = [];
            reject(err);
          });
        }
        );
      }
    });
  }

  getAllAppsList() {
    this.userandfileauditService.getAllApps().subscribe(data => {
      console.log(data);
      if (data && data.apps.nodes.length > 0) {
        data.apps.nodes.forEach(item => {
          this.appsList.push(item.appName);
        });
        this.allAppsList = data.apps.nodes;
        console.log(this.appsList);
      } else {
        this.appsList = [];
      }
    });
  }

  onDateSelectionchange(event) {
    if (this.fromDate && this.toDate) {
      this.start_date = this.addDays(this.fromDate, 0);
      this.end_date = this.addDays(this.toDate, 0);
      console.log(this.start_date, this.end_date);
      this.from = moment(this.start_date + ' 00:00').utc().format('YYYY-MM-DD HH:mm');
      this.to = moment(this.end_date + ' 23:59').utc().format('YYYY-MM-DD HH:mm');
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else if (this.fromDate === null && this.toDate) {
      this.start_date = '';
      this.end_date = this.addDays(this.toDate, 0);
      this.from = '';
      this.to = moment(this.end_date + ' 23:59').utc().format('YYYY-MM-DD HH:mm');
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else if (this.fromDate && this.toDate === null) {
      this.start_date = this.addDays(this.fromDate, 0);
      this.end_date = '';
      console.log(this.start_date, this.end_date);
      this.from = moment(this.start_date + ' 00:00').utc().format('YYYY-MM-DD HH:mm');
      this.to = '';
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else if (this.fromDate === null && this.toDate === null) {
      this.start_date = '';
      this.end_date = '';
      this.from = '';
      this.to = '';
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    }
  }

  addDays(date: Date, days: number) {
    const newdate = new Date(date.setDate(date.getDate() - days));
    return new DatePipe('en-US').transform(newdate, 'yyyy-MM-dd');
  }

  onAppSelectionChange(e) {
    if (e && e.value !== null) {
      this.selectedAppItem = e.value;
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else {
      this.selectedAppItem = '';
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    }
  }



  getAppUsers() {
    let users = ['All'];
    this.userandfileauditService.getAllUsers().subscribe((data: any) => {
      console.log(data);
      if (data && data.users.nodes.length > 0) {
        data.users.nodes.forEach(item => {
          users.push(item.email);
        });
      } else {
        users = [];
      }
    });
    this.usersList = new DataSource({
      store: new CustomStore({
        loadMode: 'raw',
        load: function () {
          return new Promise((resolve, reject) => {
            resolve(users);
          });
        },
      }),
      paginate: true
    });
  }

  onUserSelectionChange(e) {
    if (e && e.value !== null) {
      this.selectedUserItem = e.value;
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else {
      this.selectedUserItem = '';
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    }
  }

  openFileSelectionPopup() {
    this.fileSelectionPopupVisible = true;
    if (this.dataOrgComp) {
      this.dataOrgComp.isVisible = true;
    }
    this.dataOrgVisible = true;
  }

  hideDataOrgPane() {
    this.fileSelectionPopupVisible = false;
  }

  getNodeDir() {
    if (this.dataOrgComp.node_dir === '') {
      this.selected_data_org_node = this.dataOrgComp.folderInfo;
    } else {
      this.selected_data_org_node = this.dataOrgComp.visitedPaths.filter(data => data.node_dir === this.dataOrgComp.node_dir)[0];
    }
    let nodevalue = '';
    if (this.selected_data_org_node && this.selected_data_org_node['node_dir']) {
      nodevalue = this.selected_data_org_node['node_dir'];
    }
    if (this.dataOrgComp.node_dir !== '' && this.dataOrgComp.selectedIndex >= 0) {
      nodevalue += '.' + this.dataOrgComp.folderInfo.node_name;
      nodevalue = nodevalue.split('.').join('/');
      this.notifyStatus('Please select a file', 'error');
      this.isFolderValidation = true;
    } else if (this.dataOrgComp.fileSelectedIndex >= 0) {
      nodevalue = nodevalue.split('.').join('/') + '/' + this.dataOrgComp.fileObj.fileName;
      this.isFolderValidation = false;
      this.dataOrgNodeId = nodevalue;
      this.fileSelectionPopupVisible = false;
      this.currentNode = this.dataOrgComp.node_dir;
      this.dataOrgComp.isVisible = false;
      const data = this.dataOrgComp.folderInfo.node_datalake_path + '/' + this.dataOrgComp.fileObj.fileName;
      if (data) {
        const pathNew = data.split('://');
        this.filePath = pathNew[1];
        //Commented the for GCP Release as we migrated from athena to RDS.
        // const pathNew = data.split('://');
        // if (pathNew[1] && pathNew[1].includes('us-east-1')) {
        //   this.filePath = pathNew[1].replace('us-east-1-', '');
        // } else if (pathNew[1] && pathNew[1].includes('us-west-2')) {
        //   this.filePath = pathNew[1].replace('us-west-2-', '');
        // }
      }
    } else {
      nodevalue = nodevalue.split('.').join('/');
      this.isFolderValidation = true;
      this.notifyStatus('Please select a file', 'error');
    }
  }

  showMessageDetails(e) {
    if (e.rowType !== 'header' && e.column && e.column.dataField === 'message') {
      this.isMessagePopup = true;
      this.messageValue = e.data.message;
    }
  }

  hideMessagePopup() {
    this.isMessagePopup = false;
  }


  filevalueChanged(e) {
    if (e && e.value !== '') {
      console.log(this.filePath);
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    } else {
      this.filePath = '';
      if (this.userandfileAuditGrid) {
        this.userandfileAuditGrid.instance.refresh();
      }
    }
  }

  getFilePath(data) {
    let keyvalue: any;
    if (data && data !== '' && data.includes('://')) {
      const pathNew = data.split('://');
      const bucketNameWithKey = pathNew[1].split('/');
      if (bucketNameWithKey[0].includes('data-lake-raw')) {
        bucketNameWithKey.splice(0, 1);
        keyvalue = 'raw/' + bucketNameWithKey.join('/');
        return keyvalue;
      } else if (bucketNameWithKey[0].includes('data-lake-staged')) {
        bucketNameWithKey.splice(0, 1);
        keyvalue = 'staged/' + bucketNameWithKey.join('/');
        return keyvalue;
      } else if (bucketNameWithKey[0].includes('data-lake-processed')) {
        bucketNameWithKey.splice(0, 1);
        keyvalue = 'processed/' + bucketNameWithKey.join('/');
        return keyvalue;
      } else if (bucketNameWithKey[0].includes('platform-deployments')) {
        bucketNameWithKey.splice(0, 1);
        keyvalue = 'platform-deployments/' + bucketNameWithKey.join('/');
        return keyvalue;
      }
    }
  }

  notifyStatus(msg, errType) {
    this.userandfileauditService.notifyStatus(msg, errType);
  }
}
